import Vue from "vue"
import VueI18n from "vue-i18n"
import getLocale from "@/utils/locale"
import api from "@/api"

Vue.use(VueI18n)

const i18n = new VueI18n({
  locale: getLocale()
})

const initUserData = async ({ commit, dispatch }, { name }) => {
  let storedState = localStorage.getItem(`onboarding-state-${name}-${getLocale()}`)

  if (storedState) {
    commit("userData", JSON.parse(storedState))
    dispatch("fetchRecommendedBooks")
  }
}

const fetchRecommendedBooks = async ({ getters, commit }) => {
  const onboarding = await api.books.onboarding(getters.selectedTopics.join(","), i18n.locale, 12)

  commit("setTinderBooks", onboarding.books)
}

export const actions = {
  initUserData,
  fetchRecommendedBooks
}
